import type { NewsCategory } from '@/types/domains/NewsType';

const NEWS_CATEGORY_IMPORTANT: NewsCategory = {
  id: 1,
  img: {
    type: 'image',
    src: '/image/news_icon_important.jpg',
    alt: '重要',
  },
};
const NEWS_CATEGORY_NEWS: NewsCategory = {
  id: 2,
  img: {
    type: 'image',
    src: '/image/news_icon_news.jpg',
    alt: 'News',
  },
};
const NEWS_CATEGORY_PRESS: NewsCategory = {
  id: 3,
  img: {
    type: 'image',
    src: '/image/news_icon_press.jpg',
    alt: 'Press',
  },
};

/**
 * API が `newsCategory` に載せてくる区分名。絞り込みの比較に使う。
 * トップの「お知らせ」は `IMPORTANT` の全件を出すので、ここが変わると静かに0件になる。
 */
export const NEWS_CATEGORY_NAME = {
  IMPORTANT: '重要',
  NEWS: 'NEWS',
  PRESS: 'PRESS',
} as const;

export const NEWS_CATEGORY_LIST: readonly NewsCategory[] = [
  NEWS_CATEGORY_IMPORTANT,
  NEWS_CATEGORY_NEWS,
  NEWS_CATEGORY_PRESS,
] as const;
